import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './FileInput.scss';
const FileInput = (props) => {
    const [fileSelector, setfileSelector] = useState();
    const multipleUploads = props.multiple;
    const fileUploadCallback = (evt) => {
        const files = evt.target.files;
        props.onFileUpload(files);
    };
    const createFileSelector = () => {
        const fileSelector = document.createElement('input');

        fileSelector.setAttribute('type', 'file');

        if (multipleUploads) {
            fileSelector.setAttribute('multiple', 'multiple');
        }
        fileSelector.addEventListener('change', (evt) => {
            fileUploadCallback(evt);
        });

        return fileSelector;
    };

    useEffect(() => {
        setfileSelector(createFileSelector());
    }, [props.onFileUpload]);

    const onClick = () => {
        fileSelector.value = '';
        fileSelector.click();
    };

    return (
        <div className="fileInputWrapper">
            <i
                className="fileInputIcon icon-attach-1"
                onClick={onClick}
            />
        </div>
    );
};

export default FileInput;

FileInput.defaultProps = {
    multiple: false
};

FileInput.propTypes = {
    multiple: PropTypes.bool,
    onFileUpload: PropTypes.func.isRequired
};
